<app-main-layout [clickBack]="onClickBack" [disableWatchingRoutes]="true">
  <div class="main-heading">
    <h2>What to know before choosing financing</h2>
    <div class="cs-inner-html-16">
      <p>Explore how these factors affect the total cost of a $10,000 loan.</p>
    </div>
  </div>
  <div class="chart">
    <svg viewBox="0 0 36 36" class="circular-chart">
      <path class="circle-bg"
        d="M18 2.0845
          a 15.9155 15.9155 0 0 1 0 31.831
          a 15.9155 15.9155 0 0 1 0 -31.831"
        />
      @if (percentageIncrease) {
        <path class="circle"
          [attr.stroke-dasharray]="percentageIncrease + ', 100'"
        d="M18 2.0845
          a 15.9155 15.9155 0 0 1 0 31.831
          a 15.9155 15.9155 0 0 1 0 -31.831"
          />
      }
    </svg>
    @if (finalValue) {
      <div class="sum"><span>{{'$'+ finalValue}}</span></div>
    }
  </div>
  <div class="chart-description">
    <div class="item">
      <span>Initial cost</span>
      <i class="cost"></i>
    </div>
    <div class="item">
      <span>Interest</span>
      <i class="interest"></i>
    </div>
  </div>
  <div class="financing-info">
    <div class="financing-info-item">
      <div class="column">
        <strong class="title">{{loanTerm?.title}}</strong>
        <div
          [innerHtml]="loanTerm?.text"
          class="cs-inner-html-16"
        ></div>
      </div>
      <div class="column">
        <div class="names-list">
          @for (item of loanTerm?.loanTermOptions; track item) {
            <div
              class="name"
              (click)="onSelect(item, 'loanTerm loanTermOptions')"
              [ngClass]="{ selected: item.selected }"
              >
              {{ item.name }}
            </div>
          }
        </div>
      </div>
    </div>
    <div class="financing-info-item">
      <div class="column">
        <strong class="title">{{downPayment?.title}}</strong>
        <div
          [innerHtml]="downPayment?.text"
          class="cs-inner-html-16"
        ></div>
      </div>
      <div class="column">
        <div class="names-list">
          @for (item of downPayment?.downPaymentOptions; track item) {
            <div
              class="name"
              (click)="onSelect(item, 'downPayment downPaymentOptions')"
              [ngClass]="{ selected: item.selected }"
              >
              {{ item.name }}
            </div>
          }
        </div>
      </div>
    </div>
  </div>
</app-main-layout>